import { Browse } from 'spa/components/browse'
import { Layout, Sidebar } from 'spa/components/layout'
import React from 'react'
import Tags from './tags'

const display = () => {
  return (
    <Layout tabTitle="genres">
      <Sidebar>
        <Browse />
      </Sidebar>
      <Tags />
    </Layout>
  )
}

export { display as TagsDisplay }

export { Tags }

export default Tags
